import { createFileRoute } from '@tanstack/react-router'
import CreateOrEditUserCampaign from '../components/user-campaigns/CreateOrEditUserCampaign'

export const Route = createFileRoute('/_a/campaigns/create')({
  component: CreateOrEditUserCampaign,
})
